import React, { useMemo } from 'react'
import { useWeb3React } from '@web3-react/core'
import { usePollFarmsPublicData } from 'state/farms/hooks'
import { useFetchPublicPoolsData, useFetchUserPools, usePools, useVvsVault } from 'state/pools/hooks'
import { CardLayout } from 'views/Pools'
import PoolCard from 'views/Pools/components/PoolCard'
import VvsVaultCard from 'views/Pools/components/VvsVaultCard'
import { partition } from 'lodash'
import BigNumber from 'bignumber.js'
import { useTranslation } from 'contexts/Localization'
import SkeletonCard from 'views/Pool/components/SkeletonCard'
import { Text } from 'vvs-uikit'
import tokens from 'config/constants/tokens'
import usePriceXvvsUsdc from 'views/xVvs/hooks/usePriceXvvsUsdc'
import { getPoolApr } from 'utils/apr'
import usePastWeekApr from 'views/xVvs/hooks/usePastWeekApr'
import { getBalanceNumber } from 'utils/formatBalance'
import { usePollUserVvsBar } from 'state/xVvs/hooks'

const MyMines = () => {
  const { t } = useTranslation()
  const { account } = useWeb3React()
  const { pools: poolsWithoutAutoVault, userDataLoaded } = usePools()
  const stakedOnly = true
  const {
    userData: { userShares },
  } = useVvsVault()
  const accountHasVaultShares = userShares && userShares.gt(0)

  const rawPools = useMemo(() => {
    const vvsPool = poolsWithoutAutoVault.find((pool) => pool.sousId === 0)
    const vvsAutoVault = { ...vvsPool, isAutoVault: true }
    return [vvsAutoVault, ...poolsWithoutAutoVault]
  }, [poolsWithoutAutoVault])

  // Poll user data for xVVS
  usePollUserVvsBar(account)
  const xvvsPriceUsd = usePriceXvvsUsdc()
  const xvvsPastWeekApr = usePastWeekApr()
  const pools = rawPools.map((pool) => {
    if (pool.stakingToken.address !== tokens.xvvs.address) {
      return pool
    }
    // Process pools that uses xVVS as staked tokens
    const minesApr = getPoolApr(
      xvvsPriceUsd.toNumber(),
      pool.earningTokenPrice,
      getBalanceNumber(pool.totalStaked, pool.stakingToken.decimals),
      parseFloat(pool.tokenPerBlock),
    )
    return {
      ...pool,
      stakingTokenPrice: xvvsPriceUsd.toNumber(),
      apr: !pool.isFinished ? minesApr + xvvsPastWeekApr : 0,
      xvvsPastWeekApr,
      minesApr,
    }
  })

  // TODO aren't arrays in dep array checked just by reference, i.e. it will rerender every time reference changes?
  const [, openPools] = useMemo(() => partition(pools, (pool) => pool.isFinished), [pools])

  const stakedOnlyOpenPools = useMemo(
    () =>
      openPools.filter((pool) => {
        if (pool.isAutoVault) {
          return accountHasVaultShares
        }
        return pool.userData && new BigNumber(pool.userData.stakedBalance).isGreaterThan(0)
      }),
    [openPools, accountHasVaultShares],
  )

  usePollFarmsPublicData()
  useFetchPublicPoolsData()
  useFetchUserPools(account)

  const chosenPools = stakedOnly ? stakedOnlyOpenPools : openPools

  const renderBody = () => {
    if (!account) {
      return (
        <Text color="textSubtle" textAlign="center">
          {t('Connect to a wallet to view your staked Glitter Mines.')}
        </Text>
      )
    }
    if (!userDataLoaded) {
      return [0, 1, 2].map((el) => <SkeletonCard key={el} />)
    }
    if (chosenPools.length > 0) {
      return chosenPools.map((pool) =>
        pool.isAutoVault ? (
          <VvsVaultCard key="auto-vvs" pool={pool} showStakedOnly={stakedOnly} />
        ) : (
          // eslint-disable-next-line react/jsx-no-undef
          <PoolCard key={pool.sousId} pool={pool} account={account} />
        ),
      )
    }
    return (
      <Text color="textSubtle" textAlign="center">
        {t('No records. Get some VVS to start mining more VVS or partner tokens!')}
      </Text>
    )
  }

  return (
    <div>
      <CardLayout>{renderBody()}</CardLayout>
    </div>
  )
}

export default MyMines
